import { Component, OnInit, Input } from '@angular/core';
import { FormElementMembershipLevel } from '../shared/model/membership-level/form-element-membership-level.model';

@Component({
  selector: 'wl-form-builder-membership-level-display-element',
  templateUrl: 'form-builder-membership-level-display-element.component.html',
    standalone: false
})
export class FormBuilderMembershipLevelDisplayElementComponent {
  @Input('membershipLevelSettings') membershipLevelSettings: FormElementMembershipLevel;

  public constructor() {
    this.membershipLevelSettings = new FormElementMembershipLevel();
  }

  ngOnInit(): void {}
}
